import React from 'react';

import { useTheme } from '@emotion/react';

import { Divider } from 'uiToolkitV1/Divider';

function DividerForPanel() {
  const theme = useTheme();

  return <Divider borderColor={theme.colors.border.CFD7DF} my={2} />;
}

export default DividerForPanel;
